import Vue from 'vue';
import Vuetify from 'vuetify';
import ru from 'vuetify/es5/locale/ru';

import GooglePlayStoreIcon from '@/components/icons/GooglePlayStoreIcon.vue';
import VkIcon from '@/components/icons/VkIcon.vue';
import PfdoIcon from '@/components/icons/PfdoIcon.vue';

import DragIcon from '@/assets/icons/DragIcon.vue';
import TelegramIcon from '@/assets/icons/TelegramIcon.vue';
import ChristmasTreeIcon from '@/assets/icons/ChristmasTreeIcon.vue';
import LogoIcon from '@/assets/icons/LogoIcon.vue';
import LayoutSidebarLeftExpandIcon from '@/assets/icons/LayoutSidebarLeftExpandIcon.vue';
import LayoutSidebarLeftCollapseIcon from '@/assets/icons/LayoutSidebarLeftCollapseIcon.vue';

import customIcons from '@/helpers/customIcons';

import { isVcht } from '@/constants/global';
import 'vuetify/src/styles/main.sass';
import '@mdi/font/css/materialdesignicons.css';

import customColorThemes from '@/helpers/customColorThemes';
import getUIIcons from '@/helpers/getUIIcons';

Vue.use(Vuetify);

const VUETIFY_THEMES = {
  false: {
    light: {
      primary: customColorThemes.redesign.light.redesignPrimaryDarken, // '#84629F',
      primaryLighten: '#dfd6e6',
      successLighten: '#d6e4e6',
      secondary: '#424242',
      thirdy: '#E0E0E9',
      base: customColorThemes.redesign.light.redesignPrimary, // '#87619f',
      accent: '#8185D0',
      error: '#fb7181',
      info: '#2196F3',
      success: '#50AAB5',
      warning: '#FB8C00',
      white: '#FFFFFF',
      infoGrey: '#8880a3',

      ...customColorThemes.redesign.light,
      ...customColorThemes.uiTheme.light,
    },
    dark: {
      primary: customColorThemes.redesign.dark.redesignPrimaryDarken, // '#ecedf9',
      secondary: '#424242',
      thirdy: '#E0E0E9',
      base: customColorThemes.redesign.dark.redesignPrimary, // '#747197',
      accent: '#82B1FF',
      error: '#F84283',
      info: '#2196F3',
      success: '#2CA768',
      warning: '#FB8C00',
      white: '#FFFFFF',

      ...customColorThemes.redesign.dark,
      ...customColorThemes.uiTheme.dark,
    },
  },
  true: {
    light: {
      primary: '#4D5CAA',
      base: '#3f82c3',
      primaryLighten: '#e3f1ff',
      successLighten: '#d6e4e6',
      secondary: '#6088e9',
      thirdy: '#E0E0E9',
      accent: '#4D5CAA',
      error: '#fb7181',
      info: '#2196F3',
      success: '#50AAB5',
      warning: '#FB8C00',
      placeholder: '#cfd3d7',
      white: '#FFFFFF',
      infoGrey: '#2196F3',

      ...customColorThemes.redesign.light,
      ...customColorThemes.uiTheme.light,
    },
    dark: {
      primary: '#ecedf9',
      secondary: '#424242',
      thirdy: '#E0E0E9',
      base: '#747197',
      accent: '#82B1FF',
      error: '#F84283',
      info: '#2196F3',
      success: '#2CA768',
      warning: '#FB8C00',
      white: '#FFFFFF',

      ...customColorThemes.redesign.dark,
      ...customColorThemes.uiTheme.dark,
    },
  },
};

const preset = {
  breakpoint: {
    scrollBarWidth: 16,
    thresholds: {
      xs: 600,
      sm: 960,
      md: 1280,
      lg: 1920,
    },
  },
  icons: {
    iconfont: 'mdi',
    values: {
      ...customIcons,
      ...getUIIcons(), // $ui-(svg file name)
      vk: {
        component: VkIcon,
      },
      pfdo: {
        component: PfdoIcon,
      },
      'i-telegram': {
        component: TelegramIcon,
      },
      googlePlayStore: {
        component: GooglePlayStoreIcon,
      },
      idrag: {
        component: DragIcon,
      },
      christmasTree: {
        component: ChristmasTreeIcon,
      },
      logo: {
        component: LogoIcon,
      },
      layoutSidebarLeftCollapse: {
        component: LayoutSidebarLeftCollapseIcon,
      },
      layoutSidebarLeftExpand: {
        component: LayoutSidebarLeftExpandIcon,
      },
    },
  },
  theme: {
    dark: false,
    default: 'light',
    disable: false,
    options: {
      cspNonce: undefined,
      customProperties: true,
      minifyTheme: undefined,
      themeCache: undefined,
    },
    themes: VUETIFY_THEMES[isVcht],
  },
};
const opts = {
  lang: {
    locales: { ru },
    current: 'ru',
  },
  preset,
};
export default new Vuetify(opts);
